import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { Dropdown } from "react-bootstrap";
import { Link, useHistory } from "react-router-dom";
import FilterListIcon from "@mui/icons-material/FilterList";
import { serverInfo } from "../../../../../../App";
import EventImg from "../../../../../../Assets/Images/Football.jpg";
const UnfollowStar = (props) => {


  const { imageCdnUrl } = useContext(serverInfo);

  const [followingStarCat, setFollowStarCategory] = useState([]);
  const [followingCat, setStarCategory] = useState([]);
  const [suggFollowingCat, setSuggStarCategory] = useState([]);
  const history = useHistory();

  useEffect(() => {
    // const cat_slug = props.match.params.slug;

    axios.get(`/api/user/selected/starcategory`).then((res) => {
      if (res.data.status === 200) {
        setSuggStarCategory(res.data.followingStarCategory);
        setStarCategory(res.data.allSuperstar);
        setFollowStarCategory(res.data.followStarCategory);
      }
    });
  }, []);

  function handleFollowing(id) {
    if (!followingStarCat.includes(id)) {
      setFollowStarCategory([...followingStarCat, id]);
      handleChange(id);
    }

    if (followingStarCat.includes(id)) {
      const checked_data = followingStarCat.filter((item) => item !== id);
      setFollowStarCategory(checked_data);
      handleChange(id);
    }
  }

  function handleChange(data) {
    const formData = new FormData();

    formData.append("star_id", data);

    axios
      .post(`/api/user/selected/starcategory/store`, formData)
      .then((res) => {
        if (res.status === 200) {

          history.push('/star-follow-following-list');
        }
      });
  }

  const headerStyle = {
    BorderStyle: {
      borderRadius: "5px",
    },
  };

  return (
    <>
      <div className="col-md-12 mt-3 ">
        <div
          className="bg-dark my-4 d-flex justify-content-between"
          style={headerStyle.BorderStyle}
        >
          <h4 className="text-light p-3">Follow Star List</h4>
          <h4 className="p-3">
            <Dropdown>
              <Dropdown.Toggle variant="warning" id="dropdown-basic">
                <FilterListIcon />
              </Dropdown.Toggle>

              <Dropdown.Menu>
                <Dropdown.Item>
                  <Link
                    to="/star-follow-following-list"
                    className="text-warning"
                  >
                    Show all
                  </Link>
                </Dropdown.Item>
                <Dropdown.Item>
                  <Link to="/star-following-list" className="text-warning">
                    Unfollow
                  </Link>
                </Dropdown.Item>
                <Dropdown.Item>
                  <Link to="/star-follow-list" className="text-warning">
                    Follow
                  </Link>
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </h4>
        </div>

        <div className="row">
        {followingCat.map((user) => (
            <>
              {suggFollowingCat.includes(user?.super_star?.id) && (
                <div className="containerSa col-sm-12 col-md-4 col-lg-3 mb-3">
                  <div className="card follow-card">
                    <img
                      src={imageCdnUrl + user.super_star.image}
                      className="ImgCat"
                      alt={EventImg}
                      height="220px"
                    />
                    <Link to={`/starprofile/${user.super_star?.id}`} className="text-light">
                    <div className="FollowingCatText fw-bold p-2 limit">
                      {user.super_star?.first_name}{" "}
                      {user.super_star?.last_name}
                    </div>
                    </Link>
                    <button
                      className="CatBgS "
                      onClick={() => {
                        handleFollowing(user.super_star.id);
                      }}
                    >
                      {suggFollowingCat.includes(user?.super_star?.id)
                        ? "✅ Following"
                        : "➕ Follow"  }
                    </button>
                  </div>
                </div>
              )}
            </>
          ))}
        </div>
      </div>
    </>
  );
};

export default UnfollowStar;
